// components/AvatarRoot.tsx
import { Box, Center } from "@chakra-ui/react"
import { ReactNode } from "react"

interface AvatarRootProps {
  icon?: ReactNode
  bg?: string
  size?: number // size in px
}

const AvatarRoot = ({ icon, bg = "gray.500", size = 32 }: AvatarRootProps) => {
  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      borderRadius="full"
      bg={bg}
      overflow="hidden"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Center color="white" fontSize={`${size * 0.6}px`}>
        {icon}
      </Center>
    </Box>
  )
}

export default AvatarRoot
